var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.379 44.379"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "check_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.728 31.825c-2.834-2.834-5.651-5.695-8.494-8.529a.816.816 0 0 1 0-1.144l3.268-3.268a.816.816 0 0 1 1.144 0l4.672 4.672 12.013-12.022a.827.827 0 0 1 1.153 0l3.276 3.276a.8.8 0 0 1 0 1.144L18.872 31.825a.8.8 0 0 1-1.144 0"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.189 0a22.189 22.189 0 1 0 22.19 22.189A22.21 22.21 0 0 0 22.189 0",
    mask: "url(#check_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1496 1049h44v44h-44z"
  })));
};
export default SvgCheck;